var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7751 17.4333C23.3035 17.9617 23.3077 18.4858 22.7878 19.0057L19.0835 22.7101C18.5636 23.23 18.0394 23.2257 17.511 22.6973L12.1213 17.3076L6.2724 23.1565C5.7525 23.6764 5.22836 23.6722 4.69995 23.1438L0.895439 19.3393C0.367036 18.8109 0.362779 18.2867 0.882682 17.7668L6.7316 11.9179L1.42116 6.60743C0.892754 6.07902 0.888497 5.55486 1.4084 5.03496L5.11272 1.33064C5.63262 0.810739 6.15678 0.814997 6.68519 1.3434L11.9956 6.65384L17.7666 0.882912C18.2865 0.363007 18.8106 0.367264 19.339 0.895667L23.1435 4.70018C23.6719 5.22858 23.6762 5.75272 23.1563 6.27263L17.3853 12.0436L22.7751 17.4333Z",
    fill: "#612A71"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.a6b7510516fb01443e67a0c68216c89b.svg";
export { ForwardRef as ReactComponent };